import { FC } from 'react';
import cn from 'classnames';
import useClientList from '@base/list/useClientList';
import Tracker from '@base/lib/Tracker';
import ThemeEmpty from '@base/lib/ThemeEmpty';
import ThemeLoading from '@base/lib/ThemeLoading';
import Link from '@base/lib/ThemeLink';
import prodListStyles from 'app/styles/modules/prod-list.module.less';
import styles from './index.module.less';
import { getFeatureProductTrackData } from 'base/utils/features';
import { LIST_ITEM_TYPE_BANNER, LIST_TYPE_FLASH_SALE } from 'mod/product-list/constant';
import { ListBanner } from 'mod/product-list/ListBanner';
import { ListProduct, listProductStyles } from '@app/common/ListProduct';

type IProps = {
    listSn: string;
    listUrl: string;
    moduleCode: string;
    activeIndex: number;
}

export const ProductList: FC<IProps> = props => {
    const { listSn, listUrl, moduleCode, activeIndex } = props;
    const { pageData, loading } = useClientList({
        listSn,
        pageSize: 18,
    }, true);
    const { list, listConfig, trackCode } = pageData || {};

    if (loading) {
        return <ThemeLoading/>
    }
    if (!pageData) {
        return null;
    }
    if (!list?.length) {
        return <ThemeEmpty/>;
    }

    return (
        <>
            <div className={styles.list}>
                {list.map((item, index) => (
                    <div key={`${activeIndex}-${index}`} className={styles['item-wrap']}>
                        {item.type === LIST_ITEM_TYPE_BANNER ? (
                            <ListBanner
                                banners={item.banners}
                                width={288}
                            />
                        ) : (
                            <ListProduct
                                className={cn(listProductStyles.product, styles.product)}
                                item={item}
                                imageSize={230}
                                elements={[
                                    'title',
                                    'rate',
                                    'prices',
                                    'points',
                                    'progress',
                                    'options',
                                ]}
                                points={listConfig?.listType !== LIST_TYPE_FLASH_SALE}
                                progress={listConfig?.listType === LIST_TYPE_FLASH_SALE}
                                track={{
                                    module: moduleCode,
                                    listTrackCode: trackCode,
                                    position: `${activeIndex + 1}.${index + 1}`,
                                    targetPrefix: listSn,
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>

            {!!listUrl && (
                <Tracker data={{
                    targetType: 'other',
                    target: listSn + ':view-more',
                    relTarget: listSn + ':view-more',
                    module: moduleCode,
                    position: 'view-more'
                }}>
                    <div className={styles.more}>
                        <Link href={listUrl}>
                            <a>View More &gt;</a>
                        </Link>
                    </div>
                </Tracker>
            )}
        </>
    )
}
